import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin( ScrollTrigger );

function isMobileViewport() {
  return window.innerWidth < 992;
}

function getStartPosition() {
  // Align image swaps with the sticky media column top so cards don't feel "stuck"
  // ahead of / behind the visible media on laptop heights.
  if ( window.innerWidth < 992 ) {
    return 320;
  }
  if ( window.innerWidth < 1200 ) {
    return 180;
  }
  if ( window.innerHeight < 900 ) {
    return 200;
  }
  return 260;
}

function setupScrollAnimation( stickyContents, images, section ) {
  stickyContents.forEach( ( stickyContent, index ) => {
    const cardHeight = stickyContent.offsetHeight;

    gsap.to( stickyContent, {
      duration: 1,
      scrollTrigger: {
        trigger: stickyContent,
        start: () => `top ${getStartPosition()}`,
        end: () => `+=${stickyContent.offsetHeight || cardHeight}`,
        scrub: 0.8,
        invalidateOnResize: true,
        onEnterBack: () => updateImageClass( images, index, section ),
        onEnter: () => updateImageClass( images, index, section ),
      },
    } );
  } );
}

function updateImageClass( images, index, section ) {
  images.forEach( image => image.classList.remove( 'active' ) );
  if ( ! isMobileViewport() ) {
    section.querySelectorAll( 'video' ).forEach(
      vid => {
        vid.pause();
        vid.currentTime = 0;
      }
    );
    section.querySelectorAll( 'lottie-player' ).forEach(
      lottie => {
        lottie.stop();
      }
    );
  }
  images[index]?.classList.add( 'active' );
  const hasVideo = images[index]?.querySelector( 'video' );
  hasVideo?.play();
  const hasLottie = images[index]?.querySelector( 'lottie-player' );
  if ( hasLottie ) {
    hasLottie.loop = true;
    hasLottie.play();
  }
}

function handleSectionClick( section ) {
  const accordionTabs = section.querySelectorAll( '.e-acc__itm-wrpr' );

  accordionTabs.forEach( slide => {
    slide.querySelectorAll( 'video' ).forEach(
      vid => {
        vid.pause();
        vid.currentTime = 0;
      } );

    if ( slide.classList.contains( 'active' ) ) {
      const video = slide.querySelector( 'video' );
      if ( video ) {
        video.play();
      }
    }

    const itemHeader = slide.querySelector( '.e-acc__itm-hdr-wrpr' );
    itemHeader.addEventListener( 'click', () => {
      section.querySelectorAll( 'video' ).forEach(
        vid => {
          vid.pause();
          vid.currentTime = 0;
        }
      );
      const currentVideo = slide.querySelector( 'video' );
      setTimeout( () => {
        if ( currentVideo && slide.classList.contains( 'active' ) ) {
          currentVideo.currentTime = 0;
          currentVideo.play();
        }
      }, 50 );
    } );
  } );
}

document.addEventListener( 'DOMContentLoaded', () => {
  document.querySelectorAll( '.e-stn--focus-scroll-with-light-and-dark-theme' ).forEach( section => {
    const animationDiv = section.querySelector( '.e-svg' );
    const mediaWrapper = document.createElement( 'div' );
    mediaWrapper.classList.add( 'e-acc__media-wrapper' );
    const accordionTabs = section.querySelectorAll( '.e-acc__itm-wrpr' );
    const stickyContents = section.querySelectorAll( '.e-acc--focus-scroll-content-and-media .e-acc__itm' );

    accordionTabs.forEach( slide => {
      const mediaElements = slide.querySelectorAll( '.e-div--media-wrapper' );
      mediaElements.forEach( element => {
        const clonedElement = element.cloneNode( true );
        mediaWrapper.appendChild( clonedElement );
      } );
    } );

    if ( animationDiv ) {
      mediaWrapper.appendChild( animationDiv );
    }

    const container = section.querySelector( '.e-acc' );
    container?.appendChild( mediaWrapper );

    const existingHeading = section.querySelector( 'h2.wp-block-heading' );
    if ( existingHeading ) {
      const clonedHeading = existingHeading.cloneNode( true );
      mediaWrapper.prepend( clonedHeading );
    }

    const mediaImages = mediaWrapper.querySelectorAll( '.e-div--media-wrapper' );
    mediaImages[0]?.classList.add( 'active' );
    setupScrollAnimation( stickyContents, mediaImages, section );
    updateImageClass( mediaImages, 0, section );
    handleSectionClick( section );
  } );

  window.addEventListener( 'resize', () => {
    ScrollTrigger.refresh();
  } );
} );
